
import RoleList from "../components/common/RoleList/Index";
import Layout from "../components/layout";

const Role = ({}) => {
  return (
    <Layout>
      <RoleList />
    </Layout>
  );
};

export default Role;
